var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 48,
    viewBox: "0 0 78 48",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0546622 11.1004C-1.09967 30.6103 16.1957 48.0432 36.0732 47.9999C58.2831 47.9504 78 33.4979 78 10.9725C78 -2.79931 61.4597 -3.97706 59.9582 9.54314C58.0358 26.842 47.5753 38.2831 28.531 34.8118C16.9031 32.6935 10.1702 17.4367 9.78402 10.8447C9.76635 10.2374 9.62301 9.63936 9.36222 9.08474C9.10142 8.53013 8.7283 8.02974 8.26408 7.61221C7.79986 7.19468 7.2537 6.86816 6.65673 6.65128C6.05976 6.4344 5.42369 6.33142 4.78485 6.34822C4.14602 6.36501 3.51688 6.50124 2.93343 6.74914C2.34999 6.99705 1.82366 7.35177 1.38443 7.79305C0.945192 8.23433 0.601646 8.75354 0.373496 9.32101C0.145345 9.88848 0.0369958 10.4931 0.0546622 11.1004Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.40b6ff21c8b0235c7ef46b1bb54b2837.svg";
export { ForwardRef as ReactComponent };